import { render, staticRenderFns } from "./bidOpeningSummary.vue?vue&type=template&id=84dd160e&scoped=true"
import script from "./bidOpeningSummary.vue?vue&type=script&lang=js"
export * from "./bidOpeningSummary.vue?vue&type=script&lang=js"
import style0 from "./bidOpeningSummary.vue?vue&type=style&index=0&id=84dd160e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84dd160e",
  null
  
)

export default component.exports